<template>
  <div style="padding: 50px 20px; font-size: 20px">
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>服务顾问：</span>{{work.consultantName}}
      </span>
      <span>
        <span>工单号：</span>{{work.extraId||work.id}}
      </span>
    </div>
    <hr style="border:1px dashed;">
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>车牌：</span>{{work.carNo | carNo}}
      </span>
      <span>
        <span>车型：</span>{{brandNameMap[work.brandModel[0]]}} / {{work.brandModel[1]}}
      </span>
    </div>
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>车主姓名：</span>{{work.ownerName}}
      </span>
      <span>
        <span>联系电话：</span>{{work.phone}}
      </span>
    </div>
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>进厂时间：</span>{{work.enterTime?work.enterTime.format('yyyy-MM-dd hh:mm') : ''}}
      </span>
      <span>
        <span>预计交车时间：</span>{{work.estimateDeliveryTime?work.estimateDeliveryTime.format('yyyy-MM-dd hh:mm') : ''}}
      </span>
    </div>
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>付款方式：</span>{{payMethodLabelMap[work.payMethodCode]}}
      </span>
      <span>
        <span>保险公司：</span>{{insuranceCompanyMap[work.insuranceCompanyId]}}
      </span>
    </div>
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>油漆幅数：</span>{{work. lossDeterm.paintArea}}
      </span>
      <span>
        <span>钣金工时：</span>{{work.lossDeterm.disassemblyWH+work.lossDeterm.sheetMetalWH+work.lossDeterm.assemblyWH}}
      </span>
    </div>
    <div class="WorkForm">
      <span style="display: inline-block; width: 50%">
        <span>维修板件：</span>{{work. lossDeterm.sheetMetalPiece}}
      </span>
      <span>
        <span>维修费用：</span>{{work. lossDeterm.cost}}
      </span>
    </div>
    <el-table :data="work.lossDeterm.partsList" class="elTable" style="border: 1px solid darkgrey;width:100%;height:auto;">
      <el-table-column class="el-table-column" label="定损部件" prop="name" width="100%">
        <template #default="{ row }">
          <span>{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column class="el-table-column" align="center" label="拆检" prop="isDisassembly" width="100%">
        <template #default="{ row }">
          <span v-if="row.isDisassembly">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column class="el-table-column" align="center" label="钣金" prop="isSheetMetal" width="100%">
        <template #default="{ row }">
          <span v-if="row.isSheetMetal">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column class="el-table-column" align="center" label="喷漆" prop="isPaint" width="100%">
        <template #default="{ row }">
          <span v-if="row.isPaint">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column class="el-table-column" align="center" label="钣金工时" prop="sheetMetalWH" width="100%">
        <template #default="{ row }">
          {{(row.isSheetMetal || row.isDisassembly) ? row.sheetMetalWH + row.disassemblyWH + row.assemblyWH : ''}}
        </template>
      </el-table-column>
      <el-table-column class="el-table-column" align="center" label="油漆幅数" prop="paintArea" width="100%">
        <template #default="{ row }">
          {{row.isPaint ? row.paintArea : ''}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'

  export default {
    name: 'PrintWork',
    mixins: [shareDataMixin],
    props: {
      work: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
.WorkForm{
    padding: 15px 0px;
}

.elTable{
    margin-top: 10px;
    padding: 1px 0px 0px 1px;
}

@page{
    margin: 0mm;
}
</style>
